import { SvgIcon } from "@mui/material"

import { ReactComponent as Dashboard } from "./Tableau-de-bord.svg"

export const DashboardIcon = (props) => {
    return (
        <SvgIcon component={Dashboard} inheritViewBox {...props} />
    )
}
